/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carousel_LabelInputs */

const sv_carousel_label = /** @type {(inputs: Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innehållskarusell`)
};

const en_carousel_label = /** @type {(inputs: Carousel_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content carousel`)
};

/**
* | output |
* | --- |
* | "Content carousel" |
*
* @param {Carousel_LabelInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const carousel_label = /** @type {((inputs?: Carousel_LabelInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carousel_LabelInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_carousel_label(inputs)
	return en_carousel_label(inputs)
});